import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { decryptResponse } from "src/app/core/constants/constants";

@Component({
    selector: "app-recurring-payment-success",
    templateUrl: "./recurring-payment-success.component.html",
    styleUrls: ["./recurring-payment-success.component.scss"],
    standalone: false
})
export class RecurringPaymentSuccessComponent implements OnInit {
  successResponse: any;
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.successResponse = decryptResponse(params.q);
    });
  }
}
